import React from 'react';
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import plusimg from "../../images/common/plus.png"
import exportimg from "../../images/common/xlsx.png"
import editimg from "../../images/common/pencil.png"
import onimg from "../../images/admin/on-button.png"
import offimg from "../../images/admin/off-button.png"
import history from "../history";
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css'; 
import { exportToExcel } from '../../utils/exportMethods'; 
import ReactSelect from 'react-select';
import '../../css/Buttons.css';
import {config} from '../../constants';
import CircleSign from '../ui/CircleSign';
import ConfirmDialog from './pages/customComponents/ConfirmDialog';
import Maximize from '../ui/Maximize';
import Minimize from '../ui/Minimize';
import ConfirmationModal from '../ui/ConfirmationModal';
import CustomDataGrid from './pages/customComponents/CustomDataGrid';
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const validationColor = {
  control: styles => ({ ...styles, borderLeftColor: 'red',borderLeftWidth: "4px", borderRadius:"0"}),
};

const url = config.url.URL; //"http://localhost:52344";

const dataSource = createStore({
  key: "airportId",
  loadUrl: `${url}/AirportMicroservice`,
  insertUrl: `${url}/InsertOrder`,
  updateUrl: `${url}/UpdateOrder`,
  deleteUrl: `${url}/AirportMicroservice`, ///DeleteOrder
  onBeforeSend: (method, ajaxOptions) => {
    ajaxOptions.headers = {
      'accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
  },
  onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const appName = "";//ArchicubedWeb; //Production
const LoadSubmenu = (section) =>{
  history.push(appName+'/admin' + (section != '' ? '/'+section : '')) ;
}


const exportAirports = (apiData) => {
  const headers = [
    { header: 'Airport', key: 'name', autoFit: true },
    { header: 'Country/Region', key: 'country', autoFit: true },
    { header: 'Status', key: 'isEnabled', autoFit: true }
  ];
  apiData.forEach(obj => {
    delete obj.airportId;
    delete obj.geoElementId;
  });
  exportToExcel(headers, apiData, 'airports_extract', 'Airports Extract');
};


class Airports extends React.Component {
    constructor(props) {
        super(props);
        this.applyFilterTypes = [{
          key: 'auto',
          name: 'Immediately'
        }, {
          key: 'onClick',
          name: 'On Button Click'
        }];
       
        this.state = {
          showFilterRow: true,
          showHeaderFilter: false,
          currentFilter: this.applyFilterTypes[0].key,
          showColumnLines: false,
          showRowLines: true,
          showBorders: true,
          rowAlternationEnabled: true,
          optionSelected: [],
          CountriesSelected: [],
          enabledValues: [],
          allValues: [],
          idsSelected: null,
          showPublisherMenu: true,
          showAirportMenu: true,
          showVehicleMenu: true,
          showPositionMenu: true,
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
          oldCheckValue: false,
          validation: true,
          nameVal:true,
          countryVal:true,
          duplicatedValidation:true,
          selectedRowName:"",
        };

        this.dataGrid = null;
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
        this.confDiag = React.createRef();
      }

      fullscreenHandler=()=>{
        this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
      }

     // to refresh our datagrid table and close all modals
      useRefresh = () => {
        this.dataGrid.useRefresh();
        this.setState({
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
        });
      }

      selectedChanged(e) {
        this.setState({
          selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0])
        });
      }

      handleClose = () =>{
        this.setState({ showConfirmationModal: true });
      }
  
      closeConfirmationModal = ()=>{
        this.setState({ showConfirmationModal: false });
      }
  
      doubleCloseModals=()=>{
        this.setState({showModal: false, showEditModal: false, showConfirmationModal:false});
      }
  
      handleEditClose = () =>{
          this.setState({ showConfirmationModal: true });
      }

      openModal = () => {
        this.setState({optionSelected: null});
        this.setState({showModal:true, duplicatedValidation: true ,
          validation:true, nameVal:true, countryVal:true ,optionSelected:[]});
      }
    
  openEditModal = (e) => {
    this.setState({ duplicatedValidation: true, showEditModal: true, validation: true, nameVal: true, countryVal: true, optionSelected: [] });
    const airportName = e.row.data.name.trim();

    apiClient.get(`${url}/Airport/Countries/${e.row.data.airportId}`)
      .then(response => {
        /*        
                const data = response.data;
                var ids = data.map(obj => { return obj.geoElementId });
                if (ids != null) {
                  let filtered = this.state.allValues.filter(obj => {
                    return ids.includes(obj.value);
                  });
                  let editValues = this.state.allValues.filter(obj => {
                    return obj.isEnabled || ids.includes(obj.value);
                  });
                  this.setState({
                    optionSelected: filtered,
                    idsSelected: ids,
                    editCountryValues: editValues,
                  })
                }
        */
        const data = response.data;
        const itemsSelected = data.map(obj => ({ name: obj.name, id: obj.id }));
        if (itemsSelected.length > 0) {
          let editValues = this.state.allValues.filter(obj =>
            obj.isEnabled || itemsSelected.some(idObj => idObj.id === obj.value)
          );

          if (itemsSelected.length > 0) {
            const valuesIds = new Set(this.state.allValues.map((v) => v.value));

            itemsSelected.forEach((selectedItem) => {
              if (!valuesIds.has(selectedItem.id)) {
                const missingOption = {
                  label: selectedItem.name,
                  value: selectedItem.id,
                  isEnabled: false,
                  canEdit: false
                };
                this.state.allValues.push(missingOption);
              }
            });
          }
          const optionsSelected = this.state.allValues.filter((option) =>
            itemsSelected.some((selectedItem) => selectedItem.id === option.value)
          );
          optionsSelected.sort((a, b) => a.label.localeCompare(b.label));
          this.setState({
            optionSelected: optionsSelected,
            idsSelected: itemsSelected,
            editCountryValues: editValues,
          })
        }
      });

    this.setState({selectedRowIndex: e.row.data.airportId , selectedRowName : airportName}); 
    this.refs.EditName.value = e.row.data.name;
    this.refs.chk_Is_Enabled.checked = e.row.data.isEnabled;
    this.setState({oldCheckValue: e.row.data.isEnabled});
  }
  
  onExportToExcel = () => {
    apiClient.get(`${url}/AirportMicroservice/Export`)
      .then(response => {
        const data = response.data;
        if (data) {
          exportAirports(data);
          toast.success('Airports Excel export file has been generated');
        }
      });
  }

  onCreateAirport = () => {
    this.setState({ duplicatedValidation: true })
    let name = this.refs.Name.value.trim();
    let optSelect = this.state.optionSelected;

    if (name == "") {
      this.setState({ nameVal: false })
    } else {
      this.setState({ nameVal: true })
    }
    if (optSelect.length === 0 || optSelect == null) {
      this.setState({ countryVal: false })
    } else {
      this.setState({ countryVal: true })
    }

    if (name != "" && !(optSelect.length === 0 || optSelect == null)) {
      this.state.CountriesSelected = [];
      optSelect.map(select => {
        this.state.CountriesSelected.push(select.value);
      });

      let AirportInfo = {
        Name: name,
        GeoElementIds: this.state.CountriesSelected,
        IsEnabled: true
      };
      console.log(JSON.stringify(AirportInfo));
      apiClient.post(`${url}/AirportMicroservice`, AirportInfo)
        .then(response => {
          const data = response.data;
          if (data) {
            if (data.statusCode == 400) {
              this.setState({ duplicatedValidation: false })
              return;
            } else {
              toast.success('Airport has been created');
              this.doubleCloseModals();
              this.useRefresh();
            }
          }
        });
    } else {
      this.setState({ validation: false })
      return;
    }
  }

  onEditAirport = () => {
    let name = this.refs.EditName.value.trim();
    let optSelect = this.state.optionSelected;
    this.setState({ duplicatedValidation: true })

    if (name == "") {
      this.setState({ nameVal: false })
    } else {
      this.setState({ nameVal: true })
    }
    if (optSelect.length === 0 || optSelect == null) {
      this.setState({ countryVal: false })
    } else {
      this.setState({ countryVal: true })
    }

    if (name != "" && !(optSelect.length === 0 || optSelect == null)) {
      this.state.CountriesSelected = [];
      optSelect.map(select => {
        this.state.CountriesSelected.push(select.value);
      });

      let AirportInfo = {
        AirportId: this.state.selectedRowIndex,
        Name: name,
        GeoElementIds: this.state.CountriesSelected,
      };
      apiClient.put(`${url}/AirportMicroservice`, AirportInfo)
        .then(response => {
          const data = response.data;
          if (data) {
            if (data.statusCode == 400) {
              this.setState({ duplicatedValidation: false })
              return;
            } else {
              if (this.state.oldCheckValue != this.refs.chk_Is_Enabled.checked) {
                this.confDiag.current.state.status = this.refs.chk_Is_Enabled.checked
                this.confDiag.current.state.inEditMode = true;
                this.confDiag.current.state.key = this.state.selectedRowIndex;
                this.confDiag.current.handleOpenConfirmDialog();
              } else {
                toast.success('Airport has been updated');
                this.useRefresh();
              }
            }
          }
        });
    } else {
      this.setState({ validation: false });
      return;
    }
  }
    
  showDisabledEnabledToast = (value) => {
    if (!this.confDiag.current.state.inEditMode) {
      if (!value) {
        toast.success('Airport has been enabled');
      }
      else {
        toast.success('Airport has been disabled');
      }
    }
    else {
      if (value) {
        toast.success('Airport has been enabled');
      }
      else {
        toast.success('Airport has been disabled');
      }
    }
  }

  fetchCountries() {
    apiClient.get(`${url}/GeoElementMicroservice/countries`)
      .then(response => {
        const data = response.data;
        let values = data.map(item => {
          return {
            label: item.name,
            value: item.geoElementId,
            isEnabled: item.isEnabled,
            canEdit: true
          }
        });
        let enabled = values.filter(obj => {
          return obj.isEnabled;
        });
        this.setState({ allValues: values, enabledValues: enabled });
      });
  }

  // Handle selection changes by identifying the added/removed option.
  // Prevent changes if the option does not have the right or is not enabled. 
  handleChange = (selected) => {
    selected = selected || [];
    const currentSelection = this.state.optionSelected || [];

    // handle "Unselect all" button
    if (selected.length === 0) {
      const nonUnselectableOptions = currentSelection.filter(
        (opt) => !opt.canEdit
      );
      if (nonUnselectableOptions.length > 0) {
        this.setState({ optionSelected: nonUnselectableOptions });
        return;
      }
    }

    // Handle individual select/unselect
    const changedOption =
      selected.find(
        (opt) => !currentSelection.some((cur) => cur.value === opt.value)
      ) ||
      currentSelection.find(
        (opt) => !selected.some((sel) => sel.value === opt.value)
      );

    if (changedOption) {
      // Logic for preventing addition of options without rights or not enabled
      if (
        (!currentSelection.some((opt) => opt.value === changedOption.value) &&
          (!changedOption.canEdit || !changedOption.isEnabled)) ||
        !changedOption.canEdit
      ) {
        return;
      }

      // Logic for allowing removal regardless of canEdit or isEnabled
      if (
        currentSelection.some((opt) => opt.value === changedOption.value) &&
        changedOption.canEdit
      ) {
        this.setState({
          optionSelected: selected.filter(
            (opt) => opt.value !== changedOption.value
          ),
        });
        return;
      }
    }

    this.setState({ optionSelected: selected });
  };

  componentDidMount() {
    const decoded = jwt_decode(localStorage.getItem('token'));
    this.setState({
      showAirportMenu: decoded.can_manage_airport_names  === "true",
      showPublisherMenu: decoded.can_manage_publishers_vendors === "true",
      showVehicleMenu: decoded.can_manage_vehicles === "true",
      showPositionMenu: decoded.can_manage_positions === "true",
      can_export_to_excel: decoded.can_export_to_excel === "true"
    });
    this.fetchCountries();
  }

  Checkisenabled = (e) =>{
    return e.row.data.isEnabled ;
  }

  Checkisdisabled = (e) =>{
  return !e.row.data.isEnabled ;
  }

  onDelete = (e) => {
    this.confDiag.current.state.key = e.row.data.airportId;
    this.confDiag.current.state.status = e.row.data.isEnabled;
    this.confDiag.current.state.inEditMode = false;
    this.confDiag.current.handleOpenConfirmDialog();
  }

  render() {
    const columns = [
      { dataField: "isEnabled", caption: "Status", width: "110" },
      { dataField: "name", caption: "Airport", width: "100%" },
      // Add other columns specific to Profiles component
    ];

    const buttonColumn = [
      {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
      {text: "btn_enabled", icon: onimg, hint: "Disable", visible: this.Checkisenabled, name: "delete", onClick: this.onDelete},
      {text: "btn_disabled", icon: offimg, hint: "Enable", visible: this.Checkisdisabled, name: "delete", onClick: this.onDelete},
      // Additional buttons for Profiles component
    ];

    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
        <div className="div-section-title">
          <span>            
           {'Media References > Airports Management'}
          </span>
        </div>
        <div className="div-section-actions push">
          <button  className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" }  onClick={this.onExportToExcel}>
              <img className="img-section-header" src={exportimg} />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header"  onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} />
              <label>New Airport</label>
          </button>
        </div>
        </div>
        <div className="div-body-section-details-body">
        <div className="div-body-submenu">
            <div className={this.state.showPublisherMenu ? "div-submenu-link" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('publishersvendors')} >              
              <div class="div-submenu-label">
                    <label>Publishers/Vendors</label>
              </div> 
            </div>
            <div className={this.state.showAirportMenu ? "div-submenu-link active" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('airports')} >              
              <div class="div-submenu-label">
                    <label>Airports</label>
              </div> 
            </div>
            <div  className={this.state.showVehicleMenu ? "div-submenu-link" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('vehicles')} >              
              <div class="div-submenu-label">
                    <label>Vehicles</label>
              </div>               
            </div>
            <div  className={this.state.showPositionMenu ? "div-submenu-link" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('positions')} >              
              <div class="div-submenu-label">
                <label>Positions</label>
              </div>               
            </div>
          </div>
        <div  className="div-padding-20 div-grid-result">
           <CustomDataGrid
              dataSource={dataSource}
              keyExpr="airportId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
            />
      </div>
      </div>

      <Modal show={this.state.showModal} onHide={this.handleClose} size="md" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >New Airport</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>  
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Airport already exists, your updates cannot be saved. Please go back to Airports Management list to edit the corresponding form.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Airport form is not allowed</p></Row>  } 
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.nameVal ? "normal-title" : "validation-title"} font-size-12`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref="Name" placeholder="Name" className={`${!this.state.nameVal && "validation-control"}`}/>
              {!this.state.nameVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row> 
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="country">
              <Form.Label className={`${this.state.countryVal ? "normal-title" : "validation-title"} font-size-12`}>Country/Region  <CircleSign/></Form.Label>   
              <ReactSelect
                options={this.state.enabledValues}
                isMulti={true}
                styles={!this.state.countryVal && validationColor}
                closeMenuOnSelect={false}
                onChange={this.handleChange}
                value={this.state.optionSelected}
                classNamePrefix={"react-select"}
                className="custom-react-select"
              />
              {!this.state.countryVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>      
        </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onCreateAirport}>
            Create Airport
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <Modal show={this.state.showEditModal} onHide={this.handleEditClose} size="md" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >Edit Airport</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>  
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Airport already exists, your updates cannot be saved. Please go back to Airports Management list to edit the corresponding form.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Airport form is not allowed</p></Row>  }
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.nameVal ? "normal-title" : "validation-title"} font-size-12`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref="EditName" placeholder="Name" className={`${!this.state.nameVal && "validation-control"}`}/>
              {!this.state.nameVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row> 
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="country">
              <Form.Label className={`${this.state.countryVal ? "normal-title" : "validation-title"} font-size-12`}>Country/Region  <CircleSign/></Form.Label>   
              <ReactSelect
                options={this.state.editCountryValues}
                isMulti={true}
                closeMenuOnSelect={false}
                onChange={this.handleChange}
                value={this.state.optionSelected}
                className="custom-react-select"
                classNamePrefix={"react-select"}
              />
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3" controlId="formBasicCheckbox">
              <Form.Check type="checkbox" ref="chk_Is_Enabled" label="Is Enabled" />
            </Form.Group>
          </Row>   
        </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditAirport}>
            Update Airport
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>

      <ConfirmDialog ref={this.confDiag} microserviceName="AirportMicroservice" editfunction={this.showDisabledEnabledToast} refreshfunction={this.useRefresh} title="Can't enable/disable Airport" msg="You can't disable this Airport because it is still linked to enabled vehicles. Please disable vehicles first."></ConfirmDialog>

      <ToastContainer position="bottom-right"/>  
      </div>
    );
  }

    onShowFilterRowChanged(e) {
      this.setState({
        showFilterRow: e.value
      });
      this.clearFilter();
    }

    onShowHeaderFilterChanged(e) {
      this.setState({
        showHeaderFilter: e.value
      });
      this.clearFilter();
    }

    onCurrentFilterChanged(e) {
      this.setState({
        currentFilter: e.value
      });
    }

    clearFilter() {
      this.dataGrid.clearFilter();
    }
}

export default Airports;
